import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import './TimeslotSettings.module.scss';

/**
 * Import components
 */
import DropDown from 'components/UI/DropDown/DropDown';

/**
 * Import FontAwesome
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const hours = [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23 ];
const minutes = [ 0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55 ];
const timeslots = [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10 ];

const mapStateToProps = (state, props) => {
    return {
    };
};

const mapDispatchToProps = {
};

class TimeslotSettings extends Component {

    constructor() {
        super();

        this.state = {
            hours: {
                1: [ 9, 0, 10, 0 ],
                2: [ 10, 0, 11, 0 ],
                3: [ 11, 0, 12, 0 ],
                4: [ 12, 0, 13, 0 ],
                5: [ 13, 0, 14, 0 ],
                6: [ 14, 0, 15, 0 ],
                7: [ 15, 0, 16, 0 ],
                8: [ 16, 0, 17, 0 ],
                9: [ 17, 0, 18, 0 ],
                10: [ 18, 0, 19, 0 ]
            }
        };

        this.padNumber                  = this.padNumber.bind(this);
        this.getValueFromState          = this.getValueFromState.bind(this);
        this.handleValueChange          = this.handleValueChange.bind(this);
        this.save                       = this.save.bind(this);

    }

    componentDidMount() {

        if (this.props.hours &&  Object.keys(this.props.hours).length > 7) {
            this.setState({ hours: this.props.hours });
        }
    }
    
    padNumber(number) {
        return (number < 10 ? '0' : '') + number;
    }

    getValueFromState(timeslot, option) {
        return this.state.hours[timeslot][option];
    }

    handleValueChange(event) {
        let name = event.target.name;
        name = name.split('-');
        let value = parseInt(event.target.value);

        let hours = this.state.hours;
        hours[name[0]][name[1]] = value;

        this.setState({ hours: hours });
    }

    save() {
        this.props.saveHours(this.state.hours);
        this.props.handleClose();
    }

    render() {
        return (
            <div styleName="input-content">
                <div styleName='top-bar'>
                    <h1 styleName="title">Lestijden instellen</h1>
                </div>
                <div styleName='card-content' >
                    <div styleName='text' >
                        <p>Vul hier je lestijden in zodat je in je agenda een duidelijk overzicht hebt van deze tijden.</p>
                        <p>Je kunt er ook voor kiezen om alleen de begintijd in te vullen.</p>
                    </div>
                    <div styleName='timeslots' >
                        {
                            timeslots.map((timeslot, index) => {
                                if ((index + 1) > this.props.amountOfCards) {
                                    return null;
                                }
                                return (
                                    <div key={index}>
                                        <p>{`${timeslot}e uur`}</p>
                                        <div styleName='timeslot' >
                                            <DropDown borderRadius='5px' width='50px' lightborder>
                                                <select onChange={this.handleValueChange} name={`${timeslot}-0`} value={this.state.hours[timeslot][0]}>
                                                    {
                                                        hours.map((hour, index) => {
                                                            return (
                                                                <option key={index} value={hour}>{this.padNumber(hour)}</option>
                                                            );
                                                        })
                                                    }
                                                </select>
                                            </DropDown>
                                            <DropDown borderRadius='5px' width='50px' lightborder>
                                                <select onChange={this.handleValueChange} name={`${timeslot}-1`} value={this.state.hours[timeslot][1]}>
                                                    {
                                                        minutes.map((minute, index) => {
                                                            return (
                                                                <option key={index} value={minute}>{this.padNumber(minute)}</option>
                                                            );
                                                        })
                                                    }
                                                </select>
                                            </DropDown>
                                            <p>-</p>
                                            <DropDown borderRadius='5px' width='50px' lightborder>
                                                <select onChange={this.handleValueChange} name={`${timeslot}-2`} value={this.state.hours[timeslot][2]}>
                                                    {
                                                        hours.map((hour, index) => {
                                                            return (
                                                                <option key={index} value={hour}>{this.padNumber(hour)}</option>
                                                            );
                                                        })
                                                    }
                                                </select>
                                            </DropDown>
                                            <DropDown borderRadius='5px' borderRadius='5px' width='50px' lightborder>
                                                <select onChange={this.handleValueChange} name={`${timeslot}-3`} value={this.state.hours[timeslot][3]}>
                                                    {
                                                        minutes.map((minute, index) => {
                                                            return (
                                                                <option key={index} value={minute}>{this.padNumber(minute)}</option>
                                                            );
                                                        })
                                                    }
                                                </select>
                                            </DropDown>
                                        </div>
                                    </div>
                                ); 
                            })
                        }
                    </div>
                    <div styleName='buttons'>
                        <p onClick={this.save} styleName='save'>Opslaan</p>
                    </div>
                </div>
            </div>                  
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TimeslotSettings);
